import { defineComponent, createBlock, openBlock, unref, normalizeClass, withCtx, renderSlot } from "vue";
import _sfc_main$1 from "../../label/Label.js";
import { cn } from "../../../../lib/utils.js";
import { useFormField } from "./useFormField.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormLabel",
  props: {
    class: {},
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props, formField = useFormField();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), {
      class: normalizeClass(unref(cn)("data-[error=true]:text-destructive-foreground", props.class)),
      for: unref(formField).formItemId,
      "data-slot": "form-label",
      "data-error": !!unref(formField).error.value
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "for", "data-error"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormLabel.js.map
